import {PromocodeInterface} from "@/views/Admin/Events/Event/Promocodes/Promocode/Promocode.interface";
import {PromocodesServiceSchema} from "@/services/PromocodesService/PromocodesService.schema";

export const PromocodeSchema: PromocodeInterface = PromocodesServiceSchema
